import { render } from "./AblackAppPage.vue?vue&type=template&id=4ba1fd9e"
import script from "./AblackAppPage.vue?vue&type=script&lang=js"
export * from "./AblackAppPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__